import { translate } from "@/config/translator";
import { Text } from "@fluentui/react-components";
import Skeleton from "react-loading-skeleton";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { usePageSwitcher } from "./pageSwitcher/usePageSwitcher";
import { Dispatch, SetStateAction } from "react";

export declare type PageSwitcherProps = {
  currentPage: number;
  totalPages?: number;
  setCurrentPage: Dispatch<SetStateAction<number>>;
};

export default function PageSwitcher({
  currentPage,
  totalPages,
  setCurrentPage,
}: PageSwitcherProps) {
  const { lang, onNext, onPrevious } = usePageSwitcher({
    setCurrentPage,
    totalPages,
    currentPage,
  });

  return (
    <div className="flex flex-row gap-2 items-center">
      <button
        disabled={currentPage === 0}
        onClick={onPrevious}
        className={`${currentPage === 0 ? "text-disabled" : "cursor-pointer"}`}
      >
        <FontAwesomeIcon icon={faChevronLeft} size="xl" />
      </button>
      <Text size={400}>
        {translate("page", lang)}{" "}
        <Text weight="bold" size={400}>
          {currentPage + 1}
        </Text>{" "}
        {translate("of", lang)}{" "}
        <Text size={400} weight="bold">
          {totalPages ?? <Skeleton width={15} />}
        </Text>
      </Text>
      <button
        disabled={!totalPages || currentPage === totalPages - 1}
        onClick={onNext}
        className={`
          ${totalPages && currentPage === totalPages - 1 ? "text-disabled" : "cursor-pointer"}
        `}
      >
        <FontAwesomeIcon icon={faChevronRight} size="xl" />
      </button>
    </div>
  );
}
